import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import AscSortButtonPath from '../../image/AscSortButton.png';
import DescSortButtonPath from '../../image/DescSortButton.png';

export default function ZoneSubscribeColumn() {
  const [startButtonImg, setStartButtonImg] = useState(AscSortButtonPath);

  // true === ACS Sort && false === DESC
  const [startDateSort, setStartDateSort] = useState(true);

  useEffect(() => {
    if (startDateSort) setStartButtonImg(AscSortButtonPath);
    else setStartButtonImg(DescSortButtonPath)
  }, [startDateSort])

  return (
    <TopLevelWrapper>
      <SortingWrapper>
        <Column style={{ marginRight: '4px', marginLeft: '28px' }}>승인 날짜</Column>
        <SortingButton img={startButtonImg} onClick={() => setStartDateSort(!startDateSort)} style={{marginRight: '49px'}}/>
      </SortingWrapper>
      <Column style={{marginRight: '43px'}}>결제자 성함</Column>
      <Column style={{marginRight: '25px'}}>결제 구분</Column>
      <Column style={{marginRight: '420px'}}>결제 내역</Column>
      <Column style={{marginRight: '59px'}}>결제 금액</Column>
      <Column style={{marginRight: '59px'}}>남은 기간</Column>
      <Column>승인 여부</Column>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: center;
  
  // justify-content: center;
  align-items: center;

  width: 100%;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const SortingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const SortingButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  background: url(${props => props.img}) no-repeat center center;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;
